if( $('#site-main .tab-content').length ){
  var $panels = $('#site-main .tab-content');
  // when we see a tab block, grab the next block and move it inside this block
  $panels.each(function(){
    $(this).next().detach().appendTo($(this));
  });
  // set up parent .tabs element and .panels wrapper (helps with the hide/show transition)
  $panels.wrapAll('<div class="tabs"><div class="panels"></div></div>');
  // set up nav element
  $('.tabs').prepend('<ul class="nav"></ul>');
  var $nav = $('.tabs .nav');
  // look through tabs again to set up nav items
  $panels.each(function(i){
    $nav.append('<li><a href="#' + $(this).attr('id') + '">' + $(this).data('title') + '</a></li>');
  });
  var $navItems = $('.tabs .nav a');
  // activate first item
  $panels.first().addClass('active');
  $navItems.first().addClass('active');
  // enclickenate it
  $('body').on('click', '#site-main .tabs .nav a',function(e){
    e.preventDefault();
    $navItems.removeClass('active');
    $panels.removeClass('active');
    $(this).addClass('active');
    $($(this).attr('href')).addClass('active');
  });
}